/**
 *  考试模块
 */
import http from '../assets/js/http'
// 考试分类列表
export const getClassifyList = (params) => { return http.request({ url: '/exam/classify/getList', method: 'get', params: params }) }
// 保存考试分类
export const saveClassify = (params) => { return http.request({ url: '/exam/classify/save', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 考试列表
export const getList = (params) => { return http.request({ url: '/exam/getList', method: 'get', params: params }) }
// 考试设置详情
export const detail = (params) => { return http.request({ url: '/exam/detail', method: 'get', params: params }) }
// 考试设置保存
export const save = (params) => { return http.request({ url: '/exam/save', method: 'post', params: params, headers: { 'Content-Type': 'application/json;charset=utf-8' } }) }
// 考试发布
export const publish = (params) => { return http.request({ url: '/exam/publish', method: 'post', params: params }) }
// 考试结束
export const finish = (params) => { return http.request({ url: '/exam/finish', method: 'post', params: params }) }
// 考试删除
export const remove = (params) => { return http.request({ url: '/exam/remove', method: 'post', params: params }) }
// 考试清空
export const clear = (params) => { return http.request({ url: '/exam/clear', method: 'post', params: params }) }
// 检查是否存在数据
export const checkExistsData = (params) => { return http.request({ url: '/exam/classify/checkExistsData', method: 'get', params: params }) }
